import { ROUTES } from '@/common/constants/routes';
import { Router } from 'expo-router';

export function maybeNavigateBack(router: Router): void {
  if (router.canGoBack()) {
    router.back();
  } else {
    router.push(ROUTES.ROOT);
  }
}
